import { Tip } from '@hub/shared'
import React from 'react'
import './table-icon-label.component.scoped.scss'

interface TableIconLabel extends React.HTMLAttributes<HTMLDivElement> {
  title: any
  titleDetail?: any
  data: Array<{ icon: string; label: string; tooltip?: string }>
}

export default ({ title = '', data = [], className = '' }: TableIconLabel) => {
  return (
    <div className={`table-icon-label box ${className}`}>
      <div className="title">
        <h5>{title}</h5>
      </div>

      <ul>
        {data?.map((options, i) => {
          return (
            <li key={i}>
              <i className={`green ${options?.icon}`}></i>
              {options?.label}
              {options?.tooltip && <Tip className="ml-2" message={options?.tooltip}></Tip>}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
